module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Мониторинг изменений информации о контрагентах в ЕГРЮЛ.")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Для мониторинга изменений, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и мониторьте изменения в ЕГРЮЛ.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && !_vm.getClientMonitoring) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("\n        Мониторинг контрагентов в ЕГРЮЛ.\n      ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Отслеживание изменений информации о контрагентах полезно для минимизации рисков при заключении договоров.\n        Для активации этой функциональности нажмите кнопку \"Включить\". После активации все \"Мои контрагенты\" будут поставлены на мониторинг и Вы будете получать рассылку об изменениях на почту компании.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": _vm.switchMonitoringOn
    }
  }, [_vm._v("Включить")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getClientMonitoring) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-monitoring-set')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63b9ab81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/favorite/MonitoringPanel.vue
// module id = 1148
// module chunks = 1